const isValidTranslation = (prefix, translation) => {
  return !translation.startsWith(prefix);
};

export default isValidTranslation;
